<template>
  <div class="OAheader">
    <!-- 仅在本地开发模式下展示这个按钮 -->
    <el-dropdown trigger="click" @command="handleCommand">
      <div class="el-dropdown-link">
        <img src="../../assets/test.png" alt>
        <span>{{userInfo.username}}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="return">欢迎页</el-dropdown-item>
        <el-dropdown-item command="exit">安全退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <system-switch></system-switch>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import {
    jump
  } from "@/common/jump";
  export default {
    name: "OAHeader",
    computed: {
      ...mapGetters(["userInfo"])
    },
    data() {
      return {};
    },
    methods: {
      handleCommand(command) {
        if (command == "exit") {
          this.$Sky.sso.checkOut();
        } else if (command == "return") {
          this.$Sky.sso.returnSys();
        }
      }
    }
  };

</script>
<style scoped lang="scss">
  .OAheader {
    background-color: #fff;
    line-height: 60px;
    height: 60px;
    padding: 0 15px;

    .systemDropdpwn {
      font-weight: normal;
      color: #606266;
    }

    >div {
      cursor: pointer;
      padding: 0 10px;
      float: right;
      height: 60px;
      width: auto;

      &:hover {
        background: #ecf5ff;
        color: #409eff;
      }

      img {
        width: 28px;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/OAheader/OAheader.vue